import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { ImportContainer } from "../../../Model/dataProcess/importContainer";
import { ProductDataSource } from "../../../Model/dataProcess/productDataSource";
import { DataSourcesService } from "../../../Services/DataProcess/datasources.service";
import { LoginService } from "../../../Services/login.service";
import { DxFileUploaderTypes } from 'devextreme-angular/ui/file-uploader';
import { ImportContainerService } from "../../../Services/DataProcess/import-container.service";
import { BeforeSendEvent } from "devextreme/ui/file_uploader";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
    selector: "np-import-page",
    templateUrl: "./importPage.component.html",
    styleUrls: ["./importPage.component.css"],
    standalone: false
})
export class ImportPageComponent implements OnInit {
    containers: ImportContainer[];
    editedContainer: ImportContainer;
    containerSearchText: string;
    containerEditVisible = false;
    dataSources: ProductDataSource[];
    selectedContainer: ImportContainer = null;

    constructor(
        public translate: TranslateService,
        private router: Router,
        private dataSourceService: DataSourcesService,
        private loginService: LoginService,
        private importContainerService: ImportContainerService,
        private oAuthService: OAuthService
    ) {
        this.altExpr = this.altExpr.bind(this);
    }

    async ngOnInit() {
        await this.reloadLookups();
        await this.reloadContainers();
    }

    async reloadContainers() {
        this.containers = await this.importContainerService.getAll(this.loginService.currentCustomer.id) ?? [];
    }

    calculateCatalogCount(container: ImportContainer) {
        return container.catalogIds?.length ?? 0;
    }

    imageExpr(container: ImportContainer): string {
        return container.logoLink;
    }

    altExpr(): string {
        return this.translate.instant("Fehler beim Laden des Logos");
    }

    onContainerClicked(event: any) {
        const data: ImportContainer = event?.card?.data ?? event?.data ?? null;
        if (data) {
            this.selectedContainer = data;
        }
    }

    goToDetails(container: ImportContainer) {
        const id = container?.id;
        if (id) {
            this.router.navigate(['/dataprocess/imports/container-details', id]);
        }
    }

    openContainerEditPopup() {
        this.containerEditVisible = true;
        this.editedContainer = new ImportContainer();
    }

    onBeforeSendUpload(event: BeforeSendEvent) {
        event.request.withCredentials = true;
        event.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
    }

    async onUploaded(e: DxFileUploaderTypes.UploadedEvent) {
        this.editedContainer.logoLink = e.request.responseText as string;
    }

    async onContainerSaved(container: ImportContainer) {
        let containerId = container.id;
        await this.reloadContainers();
        this.selectedContainer = this.containers.find(c => c.id === containerId) ?? null;
    }

    private async reloadLookups() {
        this.dataSources = await this.dataSourceService.getAll(this.loginService.currentCustomer.id) ?? [];
    }
}
